window.app = window.app || {};
app.ui = app.ui || {};


app.ui.slider = () => {
    const defaults = {
        cellAlign: 'left',
        contain: true,
        freescroll: false,
        wrapAround: false,
        groupCells: true,
        autoplay: false,
        draggable: false
    };

    const sliders = document.querySelectorAll('.slider');

    sliders.forEach(slider => {
        // Get settings from data attribute and parse as JSON
        const settingsAttr = slider.getAttribute('data-settings');
        let customSettings = {};
        
        if (settingsAttr) {
            try {
                customSettings = JSON.parse(settingsAttr);
            } catch (e) {
                app.notifications.show('warn', 'Invalid JSON in data-settings attribute:', e);
            }
        }

        const isBackgroundVideo = 'isBackgroundVideo' in customSettings && customSettings.isBackgroundVideo;
        const videos = slider.querySelectorAll('video');
        if (isBackgroundVideo) {
            customSettings.on = {
                ready: function() {
                    if (videos[0]) videos[0].play();
                },
                change: function(index) {
                    videos.forEach(v => {
                        v.pause()
                        v.currentTime = 0;
                    });
                    if (videos[index]) videos[index].play();
                }
            };
            if (videos.length === 0) {
                customSettings.autoPlay = 2500;
            }
        }

        // Initialize Flickity with merged settings
        const flkty = new Flickity(slider, { ...defaults, ...customSettings });

        if (isBackgroundVideo) {
            videos.forEach((v, i) => {
                v.addEventListener('ended', (event) => {
                    flkty.next();
                });
            });
        }

        
        // Resize after a short delay to ensure proper initialization
        setTimeout(() => { flkty.resize(); }, 50);
        setTimeout(() => { flkty.resize(); }, 250);

        const debouncedResize = () => {
            const vp = slider.querySelector('.flickity-viewport');
            if (vp) vp.removeAttribute('style');
            flkty.resize();
        };

        window.addEventListener('resize', app.helpers.debounce(debouncedResize, 150));
    });
};
